<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('school.create_edit_modal.title')"
    class="create-edit-modal"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <el-form class="create-edit-form" :model="form" :rules="rules" ref="form">
        <upload />
        <div class="form-row">
          <elsa-input
            name="name"
            :label="$t('school.create_edit_modal.name_field.label')"
            :placeholder="$t('school.create_edit_modal.name_field.placeholder')"
            v-model.lazy="form.name"
          >
           {{ $t('school.create_edit_modal.name_field.label') }}
          </elsa-input>
          <elsa-input
            name="username"
            :label="$t('school.create_edit_modal.username_fields.label')"
            :placeholder="$t('school.create_edit_modal.username_fields.placeholder')"
            v-model.lazy="form.username"
          >
            {{ $t('school.create_edit_modal.username_fields.label') }}
          </elsa-input>
        </div>
        <div class="form-row">
          <elsa-select
            name="industry"
            :label="$t('school.create_edit_modal.industry_field.label')"
            :placeholder="$t('school.create_edit_modal.industry_field.placeholder')"
            :options="schoolIndustry"
            v-model.lazy="form.industry"
          />
          <elsa-select
            name="schoolType"
            :label="$t('school.create_edit_modal.type_field.label')"
            :placeholder="$t('school.create_edit_modal.type_field.placeholder')"
            :options="schoolTypes"
            v-model.lazy="form.schoolType"
          />
        </div>
        <div class="form-row single address-row">
          <elsa-input
            name="address"
            :label="$t('school.create_edit_modal.address_field.label')"
            :placeholder="$t('school.create_edit_modal.address_field.placeholder')"
            v-model.lazy="form.address1"
          >
            {{ $t('school.create_edit_modal.address_field.label') }}
          </elsa-input>
          <elsa-input
            name="address2"
            v-model.lazy="form.address2"
          >
          </elsa-input>
        </div>
        <div class="form-row">
          <elsa-input
            name="city"
            :label="$t('school.create_edit_modal.city_field.label')"
            :placeholder="$t('school.create_edit_modal.city_field.placeholder')"
            v-model.lazy="form.city"
          >
            {{ $t('school.create_edit_modal.city_field.label') }}
          </elsa-input>
          <elsa-input
            name="state"
            :label="$t('school.create_edit_modal.state_field.label')"
            :placeholder="$t('school.create_edit_modal.state_field.placeholder')"
            v-model.lazy="form.state"
          >
            {{ $t('school.create_edit_modal.state_field.label') }}
          </elsa-input>
          <elsa-input
            name="postcode"
            type="number"
            :label="$t('school.create_edit_modal.post_code_field.label')"
            :placeholder="$t('school.create_edit_modal.post_code_field.placeholder')"
            v-model.lazy="form.postcode"
          >
            {{ $t('school.create_edit_modal.post_code_field.label') }}
          </elsa-input>
        </div>
        <div class="form-row">
          <country-select
            name="country"
            :label="$t('school.create_edit_modal.country_field.label')"
            :placeholder="$t('school.create_edit_modal.country_field.placeholder')"
            v-model="form.country"
          />
          <div class="phone-wrapper">
            <country-select
              name="phoneCode"
              :label="$t('school.create_edit_modal.phone_field.label')"
              :placeholder="$t('school.create_edit_modal.phone_field.code')"
              v-model="form.phone_code"
              type="phone"
            />
            <elsa-input
              name="phone"
              type="number"
              :placeholder="$t('school.create_edit_modal.phone_field.placeholder')"
              v-model.lazy="form.phone_number"
            >
              {{ $t('school.create_edit_modal.phone_field.label') }}
            </elsa-input>
          </div>
        </div>
      </el-form>
    </template>
    <template v-slot:footer>
      <primary-button
        @click.native="handleSave"
      >
        {{ $t('school.create_edit_modal.create') }}
      </primary-button>
      <tertiary-button @click.native="handleCancelClick">
        {{ $t('school.create_edit_modal.cancel') }}
      </tertiary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import Upload from '@/components/common/Upload'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import ElsaInput from '@/components/common/Input'
  import ElsaSelect from '@/components/common/Select'
  import CountrySelect from '@/components/common/CountrySelect'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'

  export default {
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton,
      Upload,
      ElsaInput,
      ElsaSelect,
      CountrySelect
    },
    data() {
      return {
        form: {},
        value: '',
        rules: {
           name: { required: true, message: this.$t('school.create_edit_modal.name_field.validation_msg'), trigger: 'blur' },
           username: { required: true, message: this.$t('school.create_edit_modal.username_fields.validation_msg'), trigger: 'blur' },
           schoolType: { required: true, message: this.$t('school.create_edit_modal.school_type.validation_msg'), trigger: 'blur' },
           industry: { required: true, message: this.$t('school.create_edit_modal.industry_field.validation_msg'), trigger: 'blur' },
           address: { required: true, message: this.$t('school.create_edit_modal.address_field.validation_msg'), trigger: 'blur' },
           phoneCode: { required: true, message: this.$t('school.create_edit_modal.phone_field.validation_msg'), trigger: 'blur' },
           phone: { type: 'number', message: this.$t('school.create_edit_modal.post_code_field.validation_msg'), trigger: 'blur' },
           country: { required: true, message: this.$t('school.create_edit_modal.country_field.validation_msg'), trigger: 'blur' },
           state: { required: true, message: this.$t('school.create_edit_modal.state_field.validation_msg'), trigger: 'blur' },
           city: { required: true, message: this.$t('school.create_edit_modal.city_field.validation_msg'), trigger: 'blur' },
           postcode: [
             { required: true, message: this.$t('school.create_edit_modal.post_code_field.required_validation_msg'), trigger: 'blur' },
             { type: 'number', message: this.$t('school.create_edit_modal.post_code_field.number_validation_msg'), trigger: 'blur' }
           ]
        },
        schoolTypes: [
          {
            label: this.$t('school.create_edit_modal.school_type.youtube_type_1'),
            value: 'type-1'
          },
          {
            label: this.$t('school.create_edit_modal.school_type.youtube_type_2'),
            value: 'type-2'
           }
        ],
        schoolIndustry: [
          {
            label: this.$t('school.create_edit_modal.school_type.youtube_industry_1'),
            value: 'industry-1'
          },
          {
            label: this.$t('school.create_edit_modal.school_type.youtube_industry_2'),
            value: 'industry-2'
          }
        ],
      }
    },
    methods: {
      handleSave() {
        this.$emit('closed', 'school')
      },
      handleCancelClick() {
        this.$emit('closed')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
